import React from "react";
import { MDBRow, MDBCol, MDBView, MDBAnimation } from "mdbreact";

class Start extends React.Component {
  render() {
    return (
      <div id="driver">
        <MDBView className="view-homepage">
          <MDBRow
            style={{
              paddingTop: "40px",
              justifyContent: "left"
            }}
            >
            <MDBCol lg="6" md="6" sm="6">
              <MDBAnimation type="fadeInLeft" delay=".3s" align="left">
                <div style={{
                    display: "flex",
                    justifyContent: "left"
                    
                  }}>
                  <div className="col-lg-12 col-md-9 col-sm-6">
                    <p className="mt-2 f_heading" style={{textAlign:"left"}}>
                      <span style={{color: "#fed700"}}>Genera ingresos</span> compartiendo tus viajes cotidianos
                    </p>
                  </div>
                </div>
                
                <div style={{
                  display: "flex",
                  justifyContent: "left",
                  marginTop: "20px"
                  }}>
                  <div className="col-lg-12 col-md-9 col-sm-6">
                    <p className="dp_heading">
                    Tovo te da la oportunidad de ganar dinero sin dejar de lado tu rutina diaria.
                    </p>
                  </div>
                </div>

                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "0px"
                  }}>
                  
                </div>
              </MDBAnimation>
            </MDBCol> 
          </MDBRow>
        </MDBView>
      </div>
    );
  }
}

export default Start;
